import { Category } from '@repo/types';
import { useEffect, useState } from 'react';
import { categoryAnchorId } from 'views/Results/utils/categoriesAndMetrics';
import styles from './MetricsNavigation.module.css';
import NavigationRow from './NavigationRow';

type CategoriesListProps = {
  categories: Category[];
  activeId?: string;
  onClick?: (category: Category) => void;
  isDropdown?: boolean;
};

export type RowData = {
  height: string;
  top: number;
};

export default function CategoriesList({
  categories,
  activeId,
  onClick,
  isDropdown,
}: CategoriesListProps) {
  const [{ top, height }, setRowData] = useState<RowData>({
    height: '3rem',
    top: 0,
  });
  
  const [hasPositionedOnce, setHasPositionedOnce] = useState(false);
  const [transitionsEnabled, setTransitionsEnabled] = useState(false);

  useEffect(() => {
    if (hasPositionedOnce) setTransitionsEnabled(true);
  }, [hasPositionedOnce]);

  function handleRowData(update: RowData | ((prev: RowData) => RowData)) {
    setRowData(update);
    setHasPositionedOnce(true);
  }

  return (
    <div className={styles.categoriesList}>
      {hasPositionedOnce && (
        // Not rendered until the active category is actually known 
        <div
          className={styles.border}
          style={{
            top,
            height,
            transition: transitionsEnabled ? undefined : 'none',
          }}
        />
      )}
      {categories.map(category => (
        <NavigationRow
          key={category.name}
          category={category}
          isActive={categoryAnchorId(category) === activeId}
          onClick={onClick}
          setRowData={handleRowData}
          isDropdown={isDropdown}
        />
      ))}
    </div>
  );
}
